import Vue from 'vue';


export const  soloNumeros = {    
    inserted(el, binding) {        
        
        el.addEventListener('keypress', (event)=>{

            if(!event){
                event = window.event;
            }

            //para validar la tecla presionada
            var valid = "0123456789";    
            
            if(event.which == null){
            
                var key = String.fromCharCode(event.keyCode);    // IE
                if(valid.indexOf("" + key) == "-1"){
                    if(event.preventDefault){
                        event.preventDefault();
                    }else{
                        event.returnValue = false;
                    }
                }
            }else if(event.which != 0 && event.charCode != 0){            
                var key = String.fromCharCode(event.which);	  // All others        
            
                if(valid.indexOf("" + key) == "-1"){                    
                    if(event.preventDefault){
                        event.preventDefault();
                    }else{
                        event.returnValue = false;
                    }
                }
            }            
        });
    }
}




// WEBPACK FOOTER //
// ./src/directives/soloNumeros.js